import { Component, ElementRef, ViewContainerRef, Renderer2, Injector, ChangeDetectionStrategy, QueryList, ValueProvider } from '@angular/core';
import { ComponentBase, ComponentMixins, IComponentBase, applyMixins, PropertyCollectionInfo, setValue } from '@syncfusion/ej2-angular-base';
import { Button } from '@syncfusion/ej2-buttons';



export const /** @type {?} */ inputs: string[] = ['content','cssClass','disabled','enableHtmlSanitizer','enablePersistence','enableRtl','iconCss','iconPosition','isPrimary','isToggle','locale'];
export const /** @type {?} */ outputs: string[] = ['created'];
export const /** @type {?} */ twoWays: string[] = [];
/**
 * Represents the Angular Button Component.
 * ```html
 * <button ejs-button>Button</button>
 * ```
 */
@ComponentMixins([ComponentBase])
export class ButtonComponent extends Button implements IComponentBase {
public containerContext : any;
public tagObjects: any;
/**
 * @param {?} ngEle
 * @param {?} srenderer
 * @param {?} viewContainerRef
 * @param {?} injector
 */
constructor(private ngEle: ElementRef,
private srenderer: Renderer2,
private viewContainerRef:ViewContainerRef,
private injector: Injector) {
        super();
        this.element = this.ngEle.nativeElement;
        this.injectedModules = this.injectedModules || [];

        this.registerEvents(outputs);
        this.addTwoWay.call(this, twoWays);
        setValue('currentInstance', this, this.viewContainerRef);
        this.containerContext  = new ComponentBase();
    }
/**
 * @return {?}
 */
public ngOnInit() {
        this.containerContext.ngOnInit(this);
    }
/**
 * @return {?}
 */
public ngAfterViewInit(): void {
        this.containerContext.ngAfterViewInit(this);
    }
/**
 * @return {?}
 */
public ngOnDestroy(): void {
        this.containerContext.ngOnDestroy(this);
    }
/**
 * @return {?}
 */
public ngAfterContentChecked(): void {
        
        this.containerContext.ngAfterContentChecked(this);
    }
public registerEvents: (eventList: string[]) => void;
public addTwoWay: (propList: string[]) => void;
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: '[ejs-button]',
    inputs: inputs,
    outputs: outputs,
    template: `<ng-content ></ng-content>`,
    changeDetection: ChangeDetectionStrategy.OnPush,
    queries: {

    }
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
{type: Renderer2, },
{type: ViewContainerRef, },
{type: Injector, },
];
}

function ButtonComponent_tsickle_Closure_declarations() {
/** @type {?} */
ButtonComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ButtonComponent.ctorParameters;
/** @type {?} */
ButtonComponent.prototype.containerContext;
/** @type {?} */
ButtonComponent.prototype.tagObjects;
/** @type {?} */
ButtonComponent.prototype.registerEvents;
/** @type {?} */
ButtonComponent.prototype.addTwoWay;
/** @type {?} */
ButtonComponent.prototype.ngEle;
/** @type {?} */
ButtonComponent.prototype.srenderer;
/** @type {?} */
ButtonComponent.prototype.viewContainerRef;
/** @type {?} */
ButtonComponent.prototype.injector;
}



interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
